var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotify = function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.254.277c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10ZM14.84 14.7a.623.623 0 0 1-.858.206c-2.348-1.434-5.303-1.759-8.784-.963a.623.623 0 0 1-.277-1.216c3.809-.87 7.076-.496 9.712 1.115.294.18.387.564.207.858Zm1.224-2.723a.78.78 0 0 1-1.073.257c-2.688-1.652-6.785-2.13-9.964-1.166a.78.78 0 0 1-.453-1.492c3.631-1.102 8.146-.568 11.233 1.329a.78.78 0 0 1 .257 1.072Zm.105-2.836c-3.223-1.914-8.54-2.09-11.618-1.156a.935.935 0 1 1-.543-1.79c3.533-1.072 9.405-.865 13.115 1.338a.934.934 0 1 1-.954 1.608Z",
    fill: "#fff"
  })));
};
export default SvgSpotify;